module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/._babel-runtime@6.23.0@babel-runtime/core-js/symbol/iterator.js
 ** module id = 372
 ** module chunks = 0 1
 **/